export const carouselSliderSettings = {
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    infinite: false,
    centerMode: false,
    swipeToSlide: true,
    variableWidth: false,
    responsive: [
        {
            breakpoint: 99999,
            settings: {
                variableWidth: false,
                slidesToShow: 4,
                slidesToScroll: 3,
                arrows: true,
                infinite: false,
                swipeToSlide: true
            }
        },
        {
            breakpoint: 1450,
            settings: {
                variableWidth: false,
                slidesToShow: 4,
                slidesToScroll: 3,
                arrows: true,
                infinite: false,
                swipeToSlide: true
            }
        },
        {
            breakpoint: 1390,
            settings: {
                variableWidth: false,
                slidesToShow: 3,
                slidesToScroll: 3,
                arrows: true,
                infinite: false,
                swipeToSlide: true
            }
        },
        {
            breakpoint: 1188,
            settings: {
                variableWidth: false,
                slidesToShow: 3,
                slidesToScroll: 3,
                arrows: true,
                infinite: false,
                swipeToSlide: true
            }
        },
        {
            breakpoint: 1128,
            settings: {
                variableWidth: false,
                slidesToShow: 2,
                slidesToScroll: 2,
                arrows: true,
                infinite: false,
                swipeToSlide: true
            }
        },
        {
            breakpoint: 1023,
            settings: {
                variableWidth: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                infinite: false,
                swipeToSlide: true
            }
        }
    ]
};
export const carouselSliderSettings = {
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    infinite: false,
    centerMode: false,
    swipeToSlide: true,
    variableWidth: false,
    responsive: [
        {
            breakpoint: 99999,
            settings: {
                variableWidth: false,
                slidesToShow: 4,
                slidesToScroll: 3,
                arrows: true,
                infinite: false,
                swipeToSlide: true
            }
        },
        {
            breakpoint: 1450,
            settings: {
                variableWidth: false,
                slidesToShow: 4,
                slidesToScroll: 3,
                arrows: true,
                infinite: false,
                swipeToSlide: true
            }
        },
        {
            breakpoint: 1390,
            settings: {
                variableWidth: false,
                slidesToShow: 3,
                slidesToScroll: 3,
                arrows: true,
                infinite: false,
                swipeToSlide: true
            }
        },
        {
            breakpoint: 1188,
            settings: {
                variableWidth: false,
                slidesToShow: 3,
                slidesToScroll: 3,
                arrows: true,
                infinite: false,
                swipeToSlide: true
            }
        },
        {
            breakpoint: 1128,
            settings: {
                variableWidth: false,
                slidesToShow: 2,
                slidesToScroll: 2,
                arrows: true,
                infinite: false,
                swipeToSlide: true
            }
        },
        {
            breakpoint: 1023,
            settings: {
                variableWidth: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                infinite: false,
                swipeToSlide: true
            }
        }
    ]
};
